export default __webpack_public_path__ + "static/media/honda_cbr.8ef4b357.jpg";